import { isTestEnv } from '@tencent/pmd-tools/lib/env';


export function getUrlPath() {
  return isTestEnv()
    ? 'https://h5-test.nes.smoba.qq.com/pvpesport.next.user.feature.offline-card'
    : 'https://h5.nes.smoba.qq.com/pvpesport.next.user';
}
